import { CalculusArea, CalculusTab } from '@retail/calculus/types';

const calculusAreaMap: Partial<Record<CalculusTab, CalculusArea>> = {
  [CalculusTab.PURCHASE]: 'PURCHASE',
  [CalculusTab.FREIGHT]: 'FREIGHT',
  [CalculusTab.MARKUP]: 'MARKUP',
  [CalculusTab.PRICE_SUGGESTION]: 'PRICE_SUGGESTION',
  [CalculusTab.SALES_PRICES]: 'SALES_PRICES',
  [CalculusTab.CUSTOMER_MARKUP]: 'CUSTOMER_MARKUP',
  [CalculusTab.ROUNDING]: 'ROUNDING',
  [CalculusTab.ALL_CONDITIONS]: 'ALL_CONDITIONS'
};

export const getCalculusAreaFromTab = (tab: CalculusTab): CalculusArea => {
  const calculusArea = calculusAreaMap[tab];
  return !calculusArea ? 'PURCHASE' : calculusArea;
};
